import { render } from "./DropdownItem.vue?vue&type=template&id=bcaafece"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/DropdownItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcaafece"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcaafece', __exports__)) {
    api.reload('bcaafece', __exports__)
  }
  
  module.hot.accept("./DropdownItem.vue?vue&type=template&id=bcaafece", () => {
    api.rerender('bcaafece', render)
  })

}


export default __exports__